export default __webpack_public_path__ + "static/media/doc-admin-view.3667ef10.svg";